module.exports = __webpack_public_path__ + "img/dianxin1-1.b2fd71c6.jpg";